/* Feinkost Angelo - Anlass-Knoepfe im Kopfbereich ("Zum Dank", "Zum Geburtstag" ...).

   Stand 2026-10-04, Ansage des Inhabers: Ein Klick soll NICHT die Produktseite oeffnen,
   sondern zum Sortiment scrollen und den passenden Korb kurz hervorheben.

   So laeuft es:
   - Der Knopf ist ein echter Link auf /#sortiment (data-fa-korb = Handle des Korbs,
     "zufall" = irgendein bestellbarer Korb). Ohne JavaScript landet man also trotzdem
     beim Sortiment.
   - Mit JavaScript scrollt die Seite weich zur Karte, und sobald sie im Blick ist,
     hebt sie sich kurz an und bekommt einen Goldrand; die uebrigen Karten treten so lange
     zurueck. Nach anderthalb Sekunden ist alles wieder wie vorher (vorher 2,6 Sekunden -
     dem Inhaber war das "bisschen zu lang", 2026-10-04).
   - Wird der Knopf auf einer Seite ohne Sortiment gedrueckt, merkt sich der Browser den
     Korb und hebt ihn nach dem Laden der Startseite hervor. */
(function () {
  'use strict';

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SPEICHER = 'fa-hervor';
  var DAUER = 1500;
  var uhr = null;

  function karteFuer(korb) {
    var karten = Array.prototype.slice.call(document.querySelectorAll('#sortiment [data-fa-korb-karte]'));
    if (!karten.length) return null;
    if (!korb || korb === 'zufall') {
      var frei = karten.filter(function (k) { return !k.classList.contains('anlass--bald'); });
      if (!frei.length) frei = karten;
      return frei[Math.floor(Math.random() * frei.length)];
    }
    for (var i = 0; i < karten.length; i++) {
      if (karten[i].getAttribute('data-fa-korb-karte') === korb) return karten[i];
    }
    return null;
  }

  function aufheben(grid) {
    clearTimeout(uhr);
    grid.classList.remove('fa-hervor-aktiv');
    Array.prototype.forEach.call(grid.querySelectorAll('.fa-hervor'), function (k) {
      k.classList.remove('fa-hervor');
    });
  }

  function hervorheben(korb) {
    var bereich = document.getElementById('sortiment');
    if (!bereich) return false;

    var karte = karteFuer(korb);
    if (!karte) {
      bereich.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
      return true;
    }

    var grid = karte.parentNode;
    aufheben(grid);

    /* Die Karten sofort sichtbar machen - sie sollen nicht erst noch einblenden */
    Array.prototype.forEach.call(grid.querySelectorAll('.reveal'), function (el) {
      el.classList.remove('js-hidden');
      el.setAttribute('data-fa-gesehen', '1');
    });

    karte.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center', inline: 'nearest' });

    var gestartet = false;
    function los() {
      if (gestartet) return;
      gestartet = true;
      grid.classList.add('fa-hervor-aktiv');
      karte.classList.add('fa-hervor');
      uhr = setTimeout(function () { aufheben(grid); }, DAUER);
    }

    /* Erst hervorheben, wenn die Karte wirklich im Blick ist */
    if ('IntersectionObserver' in window) {
      var beobachter = new IntersectionObserver(function (eintraege) {
        if (eintraege[0].isIntersecting && eintraege[0].intersectionRatio >= 0.8) {
          beobachter.disconnect();
          setTimeout(los, 120);
        }
      }, { threshold: [0.8] });
      beobachter.observe(karte);
      /* Sicherheitsnetz, falls die Karte hoeher ist als das Fenster */
      setTimeout(function () { beobachter.disconnect(); los(); }, 1500);
    } else {
      los();
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var knopf = e.target.closest('a[data-fa-korb]');
    if (!knopf || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var korb = knopf.getAttribute('data-fa-korb');

    /* Aeltere Browser ohne overflow:clip: Der Kopfbereich darf nicht seitlich
       verrutscht stehen bleiben, nur weil der Knopf angetippt wurde. */
    var kopf = knopf.closest('.hero');
    if (kopf && kopf.scrollLeft) kopf.scrollLeft = 0;

    if (document.getElementById('sortiment')) {
      e.preventDefault();
      hervorheben(korb);
    } else {
      try { sessionStorage.setItem(SPEICHER, korb); } catch (err) {}
    }
  });

  function nachDemLaden() {
    var korb = null;
    try {
      korb = sessionStorage.getItem(SPEICHER);
      sessionStorage.removeItem(SPEICHER);
    } catch (err) {}
    if (korb && document.getElementById('sortiment')) {
      setTimeout(function () { hervorheben(korb); }, 350);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nachDemLaden);
  } else {
    nachDemLaden();
  }
})();
